import { useAssetConfiguration } from '@silo/config-legacy';
import { ChecksumAddress } from '@silo/types';
import { isUndefined } from '@silo/utils';
import { FC } from 'react';
import { DisabledCollateralDescription as BaseDisabledCollateralDescription } from '@silo/ui';
import { useSiloWeb3 } from '@silo/web3';

interface DisabledCollateralDescriptionProps {
  assetAddress: ChecksumAddress;
}

export const DisabledCollateralDescription: FC<DisabledCollateralDescriptionProps> = ({ assetAddress }) => {
  const { protocolInstance } = useSiloWeb3();
  const { getConfigurationForAsset } = useAssetConfiguration(protocolInstance);
  const { disabledCollateral } = getConfigurationForAsset(assetAddress);

  if (isUndefined(disabledCollateral)) {
    return null;
  }

  const { description, link } = disabledCollateral;

  return <BaseDisabledCollateralDescription description={description} link={link} />;
};
